@if (isAgent()) {
  <div class="role-assign-switcher-bar">
    <div ngbDropdown #accountDd="ngbDropdown" class="account-switcher-dropdown" autoClose="outside" placement="bottom">
      <button type="button" class="account-trigger" id="agentRoleAssignDropdown" ngbDropdownToggle>
        <span class="account-trigger-icon"><i class="bi bi-person"></i></span>
        <span class="account-trigger-text">{{ selectedAssignmentLabel }}</span>
        <span class="account-trigger-chevron"><i class="bi"
                                                 [ngClass]="accountDd.isOpen() ? 'bi-chevron-up' : 'bi-chevron-down'"></i></span>
      </button>
      <div ngbDropdownMenu aria-labelledby="agentRoleAssignDropdown" class="account-menu">
        <div class="account-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="ค้นหาบัญชี..." [value]="searchText()"
                 (input)="onSearchInput($event)" (click)="$event.stopPropagation()">
        </div>

        <div class="account-list">
          @if (showMyAccount()) {
            <button ngbDropdownItem class="account-item" [class.selected]="!selectedAssignment"
                    (click)="selectRoleAssignment(null, accountDd)">
              <span class="account-item-text">
                <span class="account-item-title">บัญชีของฉัน (ตัวแทน)</span>
              </span>
              @if (!selectedAssignment) {
                <span class="account-item-check"><i class="bi bi-check-lg"></i></span>
              }
            </button>
            @if (filteredAssignments().length > 0) {
              <div class="account-divider"></div>
            }
          }

          @if (filteredAssignments().length > 0) {
            <div class="account-section">
              <span class="account-section-title">ตัวเลือกการดำเนินการ</span>
            </div>
<!--            <div class="account-divider"></div>-->
<!--            <div class="account-group-label">ธุรกิจ</div>-->
            @for (assignment of filteredAssignments(); track assignment.id) {
              <button ngbDropdownItem class="account-item" [class.selected]="selectedAssignment?.id === assignment.id"
                      (click)="selectRoleAssignment(assignment, accountDd)">
                <span class="account-item-text">
                  <span class="account-item-title">{{ assignment.grantorName || assignment.grantorTaxId || 'ผู้มอบสิทธิ์' }}
                    @if (roleLabel(assignment.actAs)) {
                      <span class="account-item-role">{{ roleLabel(assignment.actAs) }}</span>
                    }
                  </span>
                </span>
                @if (selectedAssignment?.id === assignment.id) {
                  <span class="account-item-check"><i class="bi bi-check-lg"></i></span>
                }
              </button>
            }
          } @else if (!store.assignmentsLoading()) {
            @if (!showMyAccount()) {
              <div class="account-empty">ไม่พบบัญชีที่ค้นหา</div>
            } @else {
              <div class="account-divider"></div>
              <div class="account-empty">ยังไม่ได้รับมอบสิทธิ์</div>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
